import React from 'react';
import { Stack, Typography } from '@mui/material';

export function WidgetSecondaryData ({ title, value, border = true, position, titleStyles, valueStyles }) {
    return (
        <Stack direction={position !== undefined ? position : 'column'} alignItems={'center'} justifyContent={'center'} paddingRight={'12px'} paddingLeft={'12px'} borderRight={border ? 'solid 1px #F4AB34' : ''}>
            <Typography sx={titleStyles}>{title}</Typography>
            <Typography sx={valueStyles} color={'#F95623'}>{value}</Typography>
        </Stack>
    );
}
// Title styles
// Value styles
